import { bool, boolean } from "yup";

//const mainDomain = "http://20.9.240.224/PROJECTS/Kipinn/cms/backend/public/";
//const loginRighttest = "http://172.208.33.94:3001/api";
const equaroDomain = "https://api-staging.eqaroguarantees.com/user/v1";

//Live Domain 
const mainDomain = "https://cms.kipinn.com/backend/public/";

const GetAccessToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  if (user) return user.token;

  return null;
};

const GetUserId = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  if (user) return user.userId;

  return null;
};

const Config = {
  AxiosConfig: {
    headers: {
      authorization: `${GetAccessToken()}`,
      id: GetUserId(),
    },
  },

  userType: {
    SUPERADMIN: 1,
    MARKETING: 3,
    OPERATION: 2,
  },
  eqaroDomain: equaroDomain,
  domain: mainDomain,
  apiUrl: mainDomain + "api",
 // sampleapiurl: loginRighttest,
  certificateUrl: mainDomain + "api/upload/CERTIFICATES/",
  docUrl: mainDomain + "api/upload/",
  sessionExpiredTime: 15, // in minutes
  idleTime: 15, // in mins

  roomTypeMapping: {
    1: "Single sharing",
    2: "Double sharing",
    3: "Triple sharing",
    4: "Three plus sharing",
  },

  roomStatus: {
    1: "Vacant",
    2: "Semi occupied",
    3: "Occupied",
    4: "Inactive",
  },

  roomStatusStyle: {
    1: "bg-gray-100 text-gray-600 border-gray-300",
    2: "bg-green-100 text-green-700 border-green-300",
    3: "bg-purple-100 text-purple-700 border-purple-300",
    4: "bg-red-100 text-red-600 border-red-300",
  },

  // dueType: {
  //   RENT: 1,
  //   SECURITY: 2,
  //   MAINTENANCE: 3,
  //   ELECTRICITY: 4,
  //   REGISTRATION: 5,
  //   TECH_CHARGES: 6,
  //   OTHER: 7,
  //   AGREMENT_CHARGE: 8,
  //   FOOD: 9,
  //   FINE: 10,
  // },
   dueType: {
    RENT: 1,
    SECURITY: 2,
    MAINTENANCE: 3,
    ELECTRICITY: 4,
    REGISTRATION: 5,
    TECH_CHARGES: 6,
    OTHER: 7,
    AGREEMENT_CHARGE: 8,
    FOOD: 9,
    FINE: 10,
    SETTLEMENT: 11,
    WIFI: 12,
    GAS: 13,
    MAID_CHARGES: 14,
    DAMAGE: 15,
    KEY_CHARGES: 16,
    LAUNDRY_CHARGES: 17,
    MOVE_OUT_CHARGES: 19,
    GUEST_CHARGES: 20,
  },

  STAFF_ROLES: {
    ADMIN: 1,
    WARDEN: 2,
    ELECTRICIAN: 3,
    PLUMBER: 4,
    LAUNDRY: 5,
    CARPENTER: 6,
    PARTNER: 7,
    COOK: 8,
    HOUSEKEEPING: 9,
    SALES_PERSON: 10,
    SECURITY_GAURD: 11,
    FINANCE_ADMIN: 12,
    BACK_OFFICE: 13,
    HELP_DESK: 14,
    BROKER: 15,
    AC_TECH: 16,
    PURIFIER_TECH: 17,
  }
};

export const staffRoles =[
  {value: Config.STAFF_ROLES.ADMIN, label: "Admin"},
  {value: Config.STAFF_ROLES.WARDEN, label: "Warden"},
  {value: Config.STAFF_ROLES.ELECTRICIAN, label: "Electrician"},
  {value: Config.STAFF_ROLES.PLUMBER, label: "Plumber"},
  {value: Config.STAFF_ROLES.LAUNDRY, label: "Laundry"},
  {value: Config.STAFF_ROLES.CARPENTER, label: "Carpenter"},
  {value: Config.STAFF_ROLES.PARTNER, label: "Partner"},
  {value: Config.STAFF_ROLES.COOK, label: "Cook"},
  {value: Config.STAFF_ROLES.HOUSEKEEPING, label: "Housekeeping"},
  {value: Config.STAFF_ROLES.SALES_PERSON, label: "Sales Person"},
  {value: Config.STAFF_ROLES.SECURITY_GAURD, label: "Security Guard"},
  {value: Config.STAFF_ROLES.FINANCE_ADMIN, label: "Finance Admin"},
  {value: Config.STAFF_ROLES.BACK_OFFICE, label: "Back Office Staff"},
  {value: Config.STAFF_ROLES.HELP_DESK, label: "Help Desk"},
  {value: Config.STAFF_ROLES.BROKER, label: "Broker"},
  {value: Config.STAFF_ROLES.AC_TECH, label: "AC Technician"},
  {value: Config.STAFF_ROLES.PURIFIER_TECH, label: "Purifier Technician"},
]

// export const dueTypes = [
//   { value: 1, label: "Rent" },
//   { value: 2, label: "Security" },
//   { value: 3, label: "Maintenance" },
//   { value: 4, label: "Electricity" },
//   { value: 5, label: "Registration" },
//   { value: 6, label: "Tech Charges" },
//   { value: 7, label: "Other" },
//   { value: 8, label: "Agreement Charge" },
//   { value: 9, label: "Food" },
//   { value: 10, label: "Fine" },
// ];
export const dueTypes = [
  { value: 1, label: "Rent" },
  { value: 2, label: "Security" },
  { value: 3, label: "Maintenance" },
  { value: 4, label: "Electricity" },
  { value: 5, label: "Registration Charges" },
  { value: 6, label: "Tech Charges" },
  { value: 7, label: "Others" },
  { value: 8, label: "Agreement Charges" },
  { value: 9, label: "Food" },
  { value: 10, label: "Fine" },
  { value: 11, label: "Settlement" },
  { value: 12, label: "Wifi Charges" },
  { value: 13, label: "Gas Charges" },
  { value: 14, label: "Maid Charges" },
  { value: 15, label: "Damage Charges" },
  { value: 16, label: "Key Charges" },
  { value: 17, label: "Laundry Bill" },
  { value: 19, label: "Move-Out charges" },
  { value: 20, label: "Guest Charges" },
  
];

export const availableAmenities = [
  { label: "Balcony", value: "balcony" },
  { label: "Ac", value: "ac" },
  { label: "Tv", value: "tv" },
  { label: "Attached Bathroom", value: "attached bathroom" },
  { label: "Wi-Fi", value: "wi-fi" },
  { label: "Washing Machine", value: "washing machine" },
];

export const PaginationLimit = 10;

export const plans = [
  { value: 1, label: "Bronze" },
  { value: 2, label: "Silver" },
  { value: 3, label: "Gold" },
];

export const ForUs = (userId) => {
  if (userId === "e9ca6870-e80a-4df1-9b27-b6986fd6244a") {
    return true;
  }

  return false;
};

export const gTypeOfRoles = [
  { value: "1", label: "Registrar" },
  { value: "2", label: "Customers" },
  { value: "3", label: "Subadmins" },
  { value: "4", label: "Reports" },
];

//---CLIENT CONFIG-------
export const CLIENT_CONFIG_MAP = {
  // 1: {
  //   providerLabel:"PAYU",
  //   types: {
  //     1: {label:"KEY"}
  //   },
  // },

  // 2: {
  //   providerLabel:"CASHFREE",
  //   types: {
  //     2: {label:"SALT"}
  //   },
  // },
    2: {
      providerLabel:"CASHFREE",
      types: {
        1: {label: "VENDOR ID"},
        2: {label: "KEY"},
        3: {label: "SECRET KEY"}
      },
    },

  3: {
    providerLabel: "EASEBUZZ",
    types: {
      3: { label: "SUB ACCOUNT MID" },
    },
  },

  4: {
    providerLabel: "INTERACT",
    types: {
      1: { label: "KEY" },
    },
  },

  5: {
    providerLabel: "APP",
    types: {
      5: { label: "ANDROID" },
      6: { label: "IOS" },
    },
  },

  6: {
    providerLabel: "WATEMPLATE",
    types: {
      7: { label: "WAONBOARDING" },
      8: { label: "FOOTER" },
    },
  },

 7: {
    providerLabel: "INTERNAL",
    types: {
      1: { label: "STAY RULES", richText: true },
      2: { label: "ENABLE DUE SELECTION", boolean: true },
      9: { label: "AUTO ASSIGN COMPLAINT", boolean: true },
      10: { label: "NOTIFY PARTNER" },
      11: { label: "BOOKING AMT ENABLED", boolean: true },
      12: { label: "GATEWAY" },
      13: { label: "IS MANUAL MOVEIN", boolean: true },
      14: { label: "MANUAL REMINDER", boolean: true },
      15: { label: "CAN HIDE DUES", boolean: true },
      16: { label: "TENANT APP VERSION" },
      17: { label: "PAYMENT AGREEMENT RULE", boolean: true },
      19: { label: " DUE AUTO REMINDERS", boolean: true },
      20: { label: "EXPENSE ALLOCATION BY BEDS", boolean: true },
      21: { label: "TALLY", boolean: true },
      22: { label: "RECEIPT TERMS", boolean: true },
      23: { label: "PAYMENT EMAIL", boolean: true },
      24: { label: "RENT AGREEMENT TERMS", boolean: true },
      25: { label: "TYPE", boolean: true },
      26: { label: "IS MANUAL MOVEOUT", boolean: true },
      27: { label: "AGREEMENT END RENT", boolean: true },
      28: { label: "IS STAMP PAPER REQUIRED", boolean: true },
      29: { label: "RESET LEASE ON PROP SWITCH", boolean: true },
      30: { label: "IS PAYOUT ENABLED", boolean: true },
      31: { label: "COPY ROOM OPTIONS", boolean: true },
      32: { label: "SEPARATE SECURITY PAYMENT LINK", boolean: true },
      37: { label: "LAUNDRY LIMIT PER TENANT" },
      38: { label: "AUTO ADJUST DUES", boolean: true },
      42: { label: "PARENT ATTENDANCE NOTIFICATION", attendance: true, },
      46: { label: "ENFORCE TENANT MEAL SELECTION", boolean: true },
      47: { label: "AUTO ASSIGN COMPLAINT TO WARDEN", boolean: true, },
      48: { label: "SHOW UNASSIGNED COMPLAINTS TO WARDEN", boolean: true },
      49: { label: "CREATE RENT ON MOVEIN", boolean: true },
      50: { label: "CREATE RENT ON EXTEND STAY", boolean: true },
    },
  },


  8: {
    providerLabel: "TRANSACTION CHARGES",
    types: {
      17: { label: "PER TRANS CHARGE EASEBUZZ" },
      1: { label: "TYPE", transaction: true },
      2: { label: "THRASHOLD" },
    },
  },
  
  10: {
    providerLabel: "TENANT ONBOARDING SETTINGS",
    types: {
      18: { label: "SKIP KYC", boolean: true },
    }
  }


};


export default Config;













































































































































































































































































































































































































































// import { useState, useRef, useEffect } from "react";
// import { Formik, Field, Form } from "formik";
// import * as Yup from "yup";
// import tw from "tailwind-styled-components";
// import { toast } from "react-toastify";
// import { MdClose, MdEdit } from "react-icons/md";
// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";
// import { FormControl } from "@mui/material";
// import { Autocomplete } from "@react-google-maps/api";
// import { useMutation } from "react-query";
// import axios from "axios";

// import Config, {
//   landlord_property_type,
//   listing_type,
//   bhk_options,
//   propertyFeatures,
// } from "../../Config";

// import SelectOptionModal from "../../Components/SelectOptionModal";
// import {
//   CardWrapper,
//   CombineInputGroup,
//   FieldWrapper,
//   FieldWrappers,
//   InputGroup,
//   SelectionCard,
// } from "../../Components/Styles/InputStyles";
// import { furnishedOptions, preferredTenantOptions } from "../../helpers";
// import { FaPhone, FaWhatsapp } from "react-icons/fa";
// import Images from "../../Images";
// import SelectFeaturesModal from "../../Components/SelectFeaturesModal";
// import { useParams } from "react-router-dom";

// const InventoryForm = () => {
//   const { id: ownerId } = useParams();
//   const [showFeaturesModal, setShowFeaturesModal] = useState(false);
//   const [isBhkModalOpen, setIsBhkModalOpen] = useState(false);
//   const [apiData, setApiData] = useState(null);

//   const autocompleteRef = useRef(null);

//   const handlePlaceSelect = (setFieldValue) => {
//     const place = autocompleteRef.current.getPlace();
//     if (place?.formatted_address) {
//       setFieldValue("address", place.formatted_address);
//     }
//   };

//   // const validationSchema = Yup.object({});
//   const validationSchema = Yup.object({
//     inventoryName: Yup.string().required("Required"),
//     listingType: Yup.string().required("Required"),
//     inventoryType: Yup.string().required("Required"),
//     inventorySubType: Yup.mixed().when("inventoryType", {
//       is: (val) =>
//         [
//           Config.LANDLORD_PROPERTY_TYPE.APARTMENT_FLAT,
//           Config.LANDLORD_PROPERTY_TYPE.VILLA_INDEPENDENT_FLOOR,
//         ].includes(Number(val)),
//       then: (schema) => schema.required("Required"),
//       otherwise: (schema) => schema.notRequired(),
//     }),
//     // buildingName: Yup.string().required("Required"),
//     // flatNo: Yup.string().required("Required"),
//     address: Yup.string().required("Required"),
//     // carpetArea: Yup.number().typeError("Must be a number").required("Required"),
//     // buildUpArea: Yup.number().required("Required"),
//     rent: Yup.number().required("Required"),
//     securityDeposit: Yup.string().required("Required"),
//     maintenanceCharges: Yup.string().required("Required"),
//     furnishedType: Yup.string().required("Please select furnished type"),
//     preferredTenantType: Yup.string().required(
//       "Please select preferred tenant type",
//     ),
//     foodPreference: Yup.string().required("Please select food preference"),
//     features: Yup.array().min(1, "Select at least one feature"),
//   });
//   const initialValues = {
//     inventoryName: "",
//     listingType: "",
//     inventoryType: "",
//     inventorySubType: "",
//     buildingName: "",
//     flatNo: "",
//     address: "",
//     carpetArea: "",
//     buildUpArea: "",

//     rent: "",
//     securityDeposit: "",
//     maintenanceCharges: "",
//     furnishedType: "",
//     preferredTenantType: "",
//     foodPreference: "",
//     features: [],
//   };

//   const fetchFunction = async () => {
//     const response = await axios.get(`${Config.apiUrl}/form/share/${ownerId}`, {
//       headers: {},
//     });
//     return response.data;
//   };

//   const getSuccess = (res) => {
//     setApiData(res?.data);
//     console.log("ownerId:", ownerId);
//   };

//   const {
//     isLoading: isFetchingOwner,
//     mutate: getListMutate,
//     error,
//     data,
//     isRefetching,
//   } = useMutation(fetchFunction, {
//     onSuccess: getSuccess,
//   });

//   useEffect(() => {
//     getListMutate();
//   }, []);

//   const createInventory = async (values) => {
//     return axios.post(`${Config.apiUrl}/form/create`, values);
//   };

//   const { mutate, isLoading: isCreating } = useMutation(createInventory, {
//     onSuccess: () => toast.success("Created Successfully"),
//     onError: (err) => {
//       console.log(err);
//       toast.error("Error creating inventory");
//     },
//   });

//   // const getInputClass = (isDisabled) => {
//   //   return isDisabled
//   //     ? "bg-gray-100 cursor-not-allowed"
//   //     : "pl-2 relative rounded-md w-full flex items-center border border-gray-400 h-12 pr-6";
//   // };

//   const foodPreferenceOptions = [
//     { value: 1, label: "Veg" },
//     { value: 2, label: "Non-Veg" },
//     { value: 3, label: "Whatever" },
//   ];

//   return (
//     <MainWrapper>
//       <Header>
//         <HeaderContainer>
//           <div className="flex items-center gap-3">
//             <Logo src={Images.Logo} alt="Kipinn Logo" />
//           </div>

//           <HeaderActions>
//             <button
//               onClick={() => {
//                 const phone = apiData?.mobile;
//                 if (!phone) return;
//                 window.open(`https://wa.me/${phone}`, "_blank");
//               }}
//               className="
//                   flex items-center gap-2 
//                   bg-green-500 hover:bg-green-600 
//                   text-white 
//                   px-4 py-2 rounded-xl 
//                   text-sm font-semibold 
//                   shadow-sm hover:shadow-md
//                   transition-all duration-200
//                 "
//             >
//               <FaWhatsapp className="w-4 h-4" />
//               <span className="hidden sm:inline">WhatsApp</span>
//             </button>

//             {/* Call */}
//             <button
//               onClick={() => {
//                 const phone = apiData?.mobile;
//                 if (!phone) return;
//                 window.location.href = `tel:${phone}`;
//               }}
//               className="
//                   flex items-center gap-2 
//                   bg-primary-color hover:bg-teal-600 
//                   text-white 
//                   px-4 py-2 rounded-xl 
//                   text-sm font-semibold 
//                   shadow-sm hover:shadow-md
//                   transition-all duration-200
//                   "
//             >
//               <FaPhone className="w-4 h-4" />
//               <span className="hidden sm:inline">Call</span>
//             </button>
//           </HeaderActions>
//         </HeaderContainer>
//       </Header>
//       <Card>
//         {/* <OwnerCard>
//           <UserImage src={Images.Avatar} />

//           <div className="flex flex-col leading-tight">
//             <span className="text-sm font-semibold text-gray-900">
//               {apiData?.name || "Anurag Singh"}
//             </span>
//             <span className="text-[11px] text-gray-500">
//               {apiData?.mobile || "+91 99778 37888"}
//             </span>
//           </div>
//         </OwnerCard>

//         <Title>
//           List Your Inventory
//           <span className="block text-sm text-gray-400 font-normal">
//             Create your inventory listing
//           </span>
//           <span className="block w-20 h-[2px] bg-gradient-to-r from-primary-color to-teal-400 mx-auto mt-3 rounded-full"></span>
//         </Title> */}

//         <TopSection>
//   <OwnerCard>
//     <UserImage src={Images.Avatar} />

//     <div className="flex flex-col leading-tight min-w-0">
//   <span className="text-xs sm:text-sm font-semibold text-gray-900 truncate">
//     {apiData?.name || "Anurag Singh"}
//   </span>

//   <span className="text-[10px] sm:text-[11px] text-gray-500 truncate">
//     {apiData?.mobile || "+91 99778 37888"}
//   </span>
// </div>
//   </OwnerCard>

//   <TitleWrap>
//     <Title>List Your Inventory</Title>

//     <Subtitle>
//       Create your inventory listing
//     </Subtitle>
//   </TitleWrap>
// </TopSection>

//         <Formik
//           initialValues={initialValues}
//           validationSchema={validationSchema}
//           onSubmit={(values) => mutate(values)}
//         >
//           {({ values, setFieldValue, errors, touched, handleBlur }) => {
//             const getSelectedLabels = () => {
//               if (!values.features?.length) {
//                 return "Select Preference";
//               }

//               const selected = propertyFeatures.filter((feature) =>
//                 values.features.includes(feature.value),
//               );

//               return selected.map((f) => f.label).join(", ");
//             };
//             const handleFeaturesSelect = (selectedValues) => {
//               setFieldValue("features", selectedValues);
//             };
//             const isBhkEditable = [
//               Config.LANDLORD_PROPERTY_TYPE.APARTMENT_FLAT,
//               Config.LANDLORD_PROPERTY_TYPE.VILLA_INDEPENDENT_FLOOR,
//             ].includes(Number(values.inventoryType));

//             const getUnitLabel = () => {
//               const inventoryType = Number(values.inventoryType);

//               if (
//                 inventoryType === Config.LANDLORD_PROPERTY_TYPE.SHOP_SHOWROOM ||
//                 inventoryType === Config.LANDLORD_PROPERTY_TYPE.OFFICE
//               ) {
//                 return "Shop/Office No";
//               }

//               return "Flat/House No";
//             };

//             const isBhkRequired = [
//               Config.LANDLORD_PROPERTY_TYPE.APARTMENT_FLAT,
//               Config.LANDLORD_PROPERTY_TYPE.VILLA_INDEPENDENT_FLOOR,
//             ].includes(Number(values.inventoryType));

//             return (
//               <Form className="flex flex-col gap-4">
//                 <CombineInputGroup>
//                   <InputGroup>
//                     <Label htmlFor="inventoryName">Listing Name *</Label>
//                     <FieldWrappers
//                       className={`border ${
//                         touched.inventoryName && errors.inventoryName
//                           ? "border-red-500"
//                           : "border-gray-200"
//                       }`}
//                     >
//                       <Field
//                         type="text"
//                         name="inventoryName"
//                         id="inventoryName"
//                         autoComplete="off"
//                         placeholder="Listing name"
//                       />
//                     </FieldWrappers>
//                     {/* {touched.inventoryName && errors.inventoryName && (
//                       <p className="text-rose-600 text-sm mt-1">
//                         {errors.inventoryName}
//                       </p>
//                     )} */}
//                   </InputGroup>
//                   <InputGroup>
//                     <Label>Listing Type *</Label>
//                     <FormControl fullWidth>
//                       <Select
//                         error={
//                           touched.listingType && Boolean(errors.listingType)
//                         }
//                         sx={{
//                           "& .MuiOutlinedInput-notchedOutline": {
//                             borderColor: "#e5e7eb",
//                           },
//                           "&.Mui-error fieldset": {
//                             borderColor: "#ef4444",
//                           },
//                         }}
//                         className="px-2"
//                         id="listingType"
//                         name="listingType"
//                         value={values.listingType}
//                         onChange={(e) =>
//                           setFieldValue("listingType", e.target.value)
//                         }
//                         onBlur={handleBlur}
//                         style={{ height: "46px" }}
//                         displayEmpty
//                         renderValue={(selected) => {
//                           if (!selected) {
//                             return (
//                               <span className="text-gray-400">
//                                 Select listing type
//                               </span>
//                             );
//                           }
//                           const option = listing_type.find(
//                             (opt) => opt.value === selected,
//                           );
//                           return option ? option.label : selected;
//                         }}
//                       >
//                         <MenuItem value="" disabled>
//                           <span className="text-gray-400">Listing Type</span>
//                         </MenuItem>
//                         {listing_type.map((option) => (
//                           <MenuItem
//                             key={option.value}
//                             value={option.value}
//                             disabled={option.label === "Sale"}
//                           >
//                             {option.label}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </InputGroup>
//                 </CombineInputGroup>
//                 <CombineInputGroup>
//                   <InputGroup>
//                     <Label htmlFor="inventoryType">Inventory Type *</Label>
//                     <FormControl className="">
//                       <Select
//                         error={
//                           touched.listingType && Boolean(errors.listingType)
//                         }
//                         sx={{
//                           "& .MuiOutlinedInput-notchedOutline": {
//                             borderColor: "#e5e7eb",
//                           },
//                           "&.Mui-error fieldset": {
//                             borderColor: "#ef4444",
//                           },
//                         }}
//                         className="px-2"
//                         id="inventoryType"
//                         name="inventoryType"
//                         value={values.inventoryType}
//                         onChange={(e) => {
//                           const value = Number(e.target.value);
//                           setFieldValue("inventoryType", value);

//                           if (
//                             ![
//                               Config.LANDLORD_PROPERTY_TYPE.APARTMENT_FLAT,
//                               Config.LANDLORD_PROPERTY_TYPE
//                                 .VILLA_INDEPENDENT_FLOOR,
//                             ].includes(value)
//                           ) {
//                             setFieldValue("inventorySubType", "");
//                           }
//                         }}
//                         onBlur={handleBlur}
//                         style={{ height: "46px" }}
//                         displayEmpty
//                         renderValue={(selected) => {
//                           if (!selected) {
//                             return (
//                               <span className="text-gray-400">
//                                 Select inventory type
//                               </span>
//                             );
//                           }
//                           const option = landlord_property_type.find(
//                             (opt) => opt.value === selected,
//                           );
//                           return option ? option.label : selected;
//                         }}
//                       >
//                         <MenuItem value="" disabled>
//                           <span className="text-gray-400">Inventory Type</span>
//                         </MenuItem>
//                         {landlord_property_type.map((option) => (
//                           <MenuItem key={option.value} value={option.value}>
//                             {option.label}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </InputGroup>

//                   <InputGroup>
//                     <Label htmlFor="bhk">Bhk *</Label>

//                     <FieldWrappers
//                       onClick={() => {
//                         if (isBhkEditable) {
//                           setIsBhkModalOpen(true);
//                         }
//                       }}
//                       // className={`border border-gray-200 ${
//                       //   !isBhkEditable
//                       //     ? "bg-gray-100 cursor-not-allowed opacity-70"
//                       //     : "cursor-pointer"
//                       // }`}
//                       className={`border ${
//                         isBhkRequired &&
//                         touched.inventorySubType &&
//                         errors.inventorySubType
//                           ? "border-red-500"
//                           : "border-gray-200"
//                       } ${
//                         !isBhkEditable
//                           ? "bg-gray-100 cursor-not-allowed opacity-70"
//                           : "cursor-pointer"
//                       }`}
//                     >
//                       <Field
//                         type="text"
//                         name="bhk"
//                         id="bhk"
//                         autoComplete="off"
//                         // readOnly
//                         // value={getLocationLabel()}
//                         readOnly
//                         value={
//                           bhk_options.find(
//                             (opt) => opt.value === values.inventorySubType,
//                           )?.label || "Select BHK"
//                         }
//                         className="w-full border-none outline-none bg-transparent cursor-pointer"
//                       />
//                       <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
//                     </FieldWrappers>
//                     {/* 
//                     {touched.inventorySubType && errors.inventorySubType && (
//                       <p className="text-rose-600 text-sm mt-1">
//                         {errors.inventorySubType}
//                       </p>
//                     )} */}
//                   </InputGroup>
//                 </CombineInputGroup>
//                 <AddressInput>
//                   <InputGroup>
//                     <Label htmlFor="address">Address *</Label>

//                     <FieldWrappers
//                       className={`w-full pl-0 border ${
//                         touched.address && errors.address
//                           ? "border-red-500"
//                           : "border-gray-200"
//                       }`}
//                     >
//                       <Autocomplete
//                         className="w-full"
//                         onLoad={(autocomplete) =>
//                           (autocompleteRef.current = autocomplete)
//                         }
//                         onPlaceChanged={() => handlePlaceSelect(setFieldValue)}
//                         options={{
//                           componentRestrictions: { country: "in" },
//                           types: ["geocode"],
//                         }}
//                       >
//                         <input
//                           type="text"
//                           value={values.address}
//                           onChange={(e) => {
//                             setFieldValue("address", e.target.value);
//                           }}
//                           placeholder="Enter address"
//                           // className={getInputClass(false)}
//                           className="w-full pr-6 bg-transparent border-none outline-none pl-2"
//                         />
//                       </Autocomplete>
//                       {values.address && (
//                         <button
//                           type="button"
//                           onClick={() => setFieldValue("address", "")}
//                           className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700"
//                         >
//                           <MdClose />
//                         </button>
//                       )}
//                     </FieldWrappers>

//                     {/* {touched.address && errors.address && (
//                       <p className="text-rose-600 text-sm mt-1">
//                         {errors.address}
//                       </p>
//                     )} */}
//                   </InputGroup>
//                 </AddressInput>
//                 <CombineInputGroup>
//                   <InputGroup>
//                     <Label>Building/Tower/Block</Label>
//                     <FieldWrappers
//                       className={`border ${
//                         touched.buildingName && errors.buildingName
//                           ? "border-red-500"
//                           : "border-gray-200"
//                       }`}
//                     >
//                       <Field
//                         type="text"
//                         id="buildingName"
//                         name="buildingName"
//                         placeholder="Enter building name"
//                       />
//                     </FieldWrappers>
//                   </InputGroup>

//                   <InputGroup>
//                     <Label>{getUnitLabel()}</Label>
//                     <FieldWrappers
//                       className={`border ${
//                         touched.flatNo && errors.flatNo
//                           ? "border-red-500"
//                           : "border-gray-200"
//                       }`}
//                     >
//                       <Field
//                         name="flatNo"
//                         placeholder={`Enter ${getUnitLabel().toLowerCase()}`}
//                       />
//                     </FieldWrappers>
//                   </InputGroup>
//                 </CombineInputGroup>

//                 <CombineInputGroup>
//                   <InputGroup>
//                     <Label htmlFor="carpetArea">Carpet Area (sqft)</Label>
//                     <FieldWrappers
//                       className={`border ${
//                         touched.carpetArea && errors.carpetArea
//                           ? "border-red-500"
//                           : "border-gray-200"
//                       }`}
//                     >
//                       <Field
//                         type=""
//                         name="carpetArea"
//                         id="carpetArea"
//                         // className={getInputClass()}
//                         placeholder="Enter carpet area"
//                         onKeyDown={(e) => {
//                           if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
//                             e.preventDefault();
//                           }
//                         }}
//                       />
//                     </FieldWrappers>
//                   </InputGroup>

//                   <InputGroup>
//                     <Label htmlFor="buildUpArea">Built-up Area (sqft)</Label>
//                     <FieldWrappers
//                       className={`border ${
//                         touched.buildUpArea && errors.buildUpArea
//                           ? "border-red-500"
//                           : "border-gray-200"
//                       }`}
//                     >
//                       <Field
//                         type=""
//                         name="buildUpArea"
//                         id="buildUpArea"
//                         placeholder="Enter build-up area"
//                         // className={getInputClass()}
//                         onKeyDown={(e) => {
//                           if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
//                             e.preventDefault();
//                           }
//                         }}
//                       />
//                     </FieldWrappers>
//                   </InputGroup>
//                 </CombineInputGroup>
//                 <InputGroup>
//                   <Label htmlFor="rent">Monthly Rent (₹) *</Label>
//                   <FieldWrappers
//                     className={`border ${
//                       touched.rent && errors.rent
//                         ? "border-red-500"
//                         : "border-gray-200"
//                     }`}
//                   >
//                     <Field
//                       type="text"
//                       name="rent"
//                       id="rent"
//                       autoComplete="off"
//                       placeholder="Enter monthly rent"
//                       min="1000"
//                       max="5000000"
//                       className=""
//                     />
//                   </FieldWrappers>
//                   {/* {touched.rent && errors.rent && (
//                     <p className="text-rose-600 text-sm mt-1">{errors.rent}</p>
//                   )} */}
//                 </InputGroup>

//                 <CombineInputGroup>
//                   <InputGroup>
//                     <Label htmlFor="securityDeposit">
//                       Security Deposit (₹)
//                     </Label>
//                     <FieldWrappers
//                       className={`border ${
//                         touched.securityDeposit && errors.securityDeposit
//                           ? "border-red-500"
//                           : "border-gray-200"
//                       }`}
//                     >
//                       <Field
//                         type="number"
//                         name="securityDeposit"
//                         id="securityDeposit"
//                         autoComplete="off"
//                         placeholder="Enter security deposit"
//                         min="1"
//                         max="1000000"
//                       />
//                     </FieldWrappers>
//                     {/* {touched.securityDeposit && errors.securityDeposit && (
//                       <p className="text-rose-600 text-sm mt-1">
//                         {errors.securityDeposit}
//                       </p>
//                     )} */}
//                   </InputGroup>

//                   <InputGroup>
//                     <Label htmlFor="maintenanceMoCharges">
//                       Maintenance Charges (₹)
//                     </Label>
//                     <FieldWrappers
//                       className={`border ${
//                         touched.maintenanceCharges && errors.maintenanceCharges
//                           ? "border-red-500"
//                           : "border-gray-200"
//                       }`}
//                     >
//                       <Field
//                         type="number"
//                         name="maintenanceCharges"
//                         id="maintenanceCharges"
//                         autoComplete="off"
//                         placeholder="Enter maintenance charges"
//                         min="0"
//                       />
//                     </FieldWrappers>
//                     {/* {touched.maintenanceCharges &&
//                       errors.maintenanceCharges && (
//                         <p className="text-rose-600 text-sm mt-1">
//                           {errors.maintenanceCharges}
//                         </p>
//                       )} */}
//                   </InputGroup>
//                 </CombineInputGroup>

//                 {/* Furnished Type */}
//                 <InputGroup>
//                   <Label>Furnished Type *</Label>
//                   <CardWrapper>
//                     {furnishedOptions.map((option) => (
//                       <SelectionCard
//                         key={option.value}
//                         type="button"
//                         onClick={(e) => {
//                           e.preventDefault();
//                           setFieldValue("furnishedType", option.value);
//                         }}
//                         className={
//                           values.furnishedType === option.value
//                             ? "bg-[#26A69A] text-white"
//                             : "bg-gray-50 text-gray-800"
//                         }
//                       >
//                         <span className="text-sm">{option.label}</span>
//                       </SelectionCard>
//                     ))}
//                   </CardWrapper>
//                   {touched.furnishedType && errors.furnishedType && (
//                     <p className="text-rose-600 text-sm mt-1">
//                       {errors.furnishedType}
//                     </p>
//                   )}
//                 </InputGroup>
//                 <InputGroup>
//                   <Label>Preferred Tenant Type *</Label>
//                   <CardWrapper>
//                     {preferredTenantOptions.map((option) => (
//                       <SelectionCard
//                         key={option.value}
//                         type="button"
//                         onClick={(e) => {
//                           e.preventDefault();
//                           setFieldValue("preferredTenantType", option.value);
//                         }}
//                         className={
//                           values.preferredTenantType === option.value
//                             ? "bg-[#26A69A] text-white"
//                             : "bg-gray-50 text-gray-800"
//                         }
//                       >
//                         <span className="text-sm">{option.label}</span>
//                       </SelectionCard>
//                     ))}
//                   </CardWrapper>
//                   {touched.preferredTenantType &&
//                     errors.preferredTenantType && (
//                       <p className="text-rose-600 text-sm mt-1">
//                         {errors.preferredTenantType}
//                       </p>
//                     )}
//                 </InputGroup>

//                 <InputGroup>
//                   <Label>Food Preference *</Label>
//                   <CardWrapper>
//                     {foodPreferenceOptions.map((option) => (
//                       <SelectionCard
//                         key={option.value}
//                         type="button"
//                         onClick={(e) => {
//                           e.preventDefault();
//                           setFieldValue("foodPreference", option.value);
//                         }}
//                         className={
//                           values.foodPreference === option.value
//                             ? "bg-[#26A69A] text-white"
//                             : "bg-gray-50 text-gray-800"
//                         }
//                       >
//                         <span className="text-sm">{option.label}</span>
//                       </SelectionCard>
//                     ))}
//                   </CardWrapper>
//                   {touched.foodPreference && errors.foodPreference && (
//                     <p className="text-rose-600 text-sm mt-1">
//                       {errors.foodPreference}
//                     </p>
//                   )}
//                 </InputGroup>

//                 <InputGroup>
//                   <Label>Custom Features *</Label>

//                   <FieldWrappers
//                     className={`border ${
//                       touched.features && errors.features
//                         ? "border-red-500"
//                         : "border-gray-200"
//                     }`}
//                     onClick={() => setShowFeaturesModal(true)}
//                     // className="border border-gray-400"
//                   >
//                     <Field
//                       type="text"
//                       readOnly
//                       value={getSelectedLabels()}
//                       className="w-full border-none outline-none bg-transparent cursor-pointer"
//                     />

//                     <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
//                   </FieldWrappers>

//                   {/* {touched.features && errors.features && (
//                     <p className="text-rose-600 text-sm mt-1">
//                       {errors.features}
//                     </p>
//                   )} */}
//                 </InputGroup>

//                 {/* Submit */}
//                 <SubmitWrapper>
//                   <SubmitBtn type="submit" disabled={isCreating}>
//                     {isCreating ? "Saving..." : "Add Inventory"}
//                   </SubmitBtn>
//                 </SubmitWrapper>

//                 <SelectOptionModal
//                   isOpen={isBhkModalOpen}
//                   onClose={() => setIsBhkModalOpen(false)}
//                   options={bhk_options}
//                   selectedValue={values.inventorySubType}
//                   onSelect={(val) => {
//                     setFieldValue("inventorySubType", val);
//                     setIsBhkModalOpen(false);
//                   }}
//                   width="1/3"
//                 />

//                 <SelectFeaturesModal
//                   isOpen={showFeaturesModal}
//                   onClose={() => setShowFeaturesModal(false)}
//                   options={propertyFeatures}
//                   selectedValue={values.features}
//                   onSelect={handleFeaturesSelect}
//                   title="Select Features"
//                   searchPlaceholder="Search Features..."
//                   width="1/3"
//                 />
//               </Form>
//             );
//           }}
//         </Formik>
//       </Card>
//       <Footer>© {new Date().getFullYear()} Kipinn. All rights reserved.</Footer>
//     </MainWrapper>
//   );
// };

// export default InventoryForm;

// const MainWrapper = tw.div`
//   min-h-screen bg-gray-50 flex flex-col
// `;
// const Header = tw.header`
//   sticky top-0 z-50 
//   bg-white/80 backdrop-blur-lg 
//   border-b border-gray-100
// `;
// const HeaderContainer = tw.div`
//   max-w-[1040px] mx-auto 
//   w-full
//   flex items-center justify-between
//   py-3 px-5
// `;
// const Logo = tw.img`w-16 sm:w-20`;
// const HeaderActions = tw.div`
//   flex items-center gap-2 sm:gap-3
// `;
// const Card = tw.div`
//   w-full max-w-5xl py-3 px-5 mx-auto mt-1
// `;
// // const OwnerCard = tw.div`
// //   mx-auto mt-3 mb-2 
// //   flex items-center gap-2

// //   bg-white/80 backdrop-blur-md
// //   border border-gray-200
  
// //   rounded-full
// //   px-4 py-2      
  
// //   shadow-sm hover:shadow-md
  
// //   transition-all duration-300
// //   w-fit             
// // `;
// // const UserImage = tw.img`flex items-center justify-center w-8 h-8 rounded-full bg-primary-color text-white flex-shrink-0`;

// // const Title = tw.h2`
// //   text-xl font-bold 
// //   text-gray-900 
// //   tracking-tight 
// //   text-center 
// //   mb-5 
// //   relative
// // `;
// const Label = tw.label`
//   text-sm text-gray-600 font-medium
// `;
// const AddressInput = tw.div`grid md:col-span-2 col-span-1`;
// const SubmitWrapper = tw.div`
//   flex justify-end mt-6
// `;
// const SubmitBtn = tw.button`
//   px-6 py-2 text-white rounded-xl hover:bg-[#009688] text-white rounded-md shadow-md bg-gradient-to-r from-primary-color to-teal-400 transition disabled:opacity-50
// `;

// const Footer = tw.div`border-t mt-8 pt-4 text-center text-xs text-gray-400 mb-5`;



// const TopSection = tw.div`
//   flex items-center justify-between
//   gap-4

//   mb-6 mt-3
//   bg-white/70 backdrop-blur-md
//   border border-gray-200
//   rounded-2xl
//   p-4 shadow-sm
// `;

// const TitleWrap = tw.div`
//   flex flex-col
//   text-right
// `;

// const Title = tw.h2`
//   text-base sm:text-2xl
//   font-bold
//   text-gray-900
//   leading-tight
// `;

// const Subtitle = tw.p`
//   text-[10px] sm:text-sm
//   text-gray-500
// `;

// const OwnerCard = tw.div`
//   flex items-center gap-2 sm:gap-3

//   bg-white
//   border border-gray-200
//   rounded-full

//   px-2 sm:px-4
//   py-2
//   shadow-sm

//   min-w-0
// `;

// const UserImage = tw.img`
//   w-7 h-7 sm:w-9 sm:h-9
//   rounded-full
//   bg-primary-color
//   flex-shrink-0
// `;

// // const TopSection = tw.div`
// //   flex flex-col md:flex-row md:items-center md:justify-between
// //   gap-4 mb-6 mt-3
// //   bg-white/70 backdrop-blur-md
// //   border border-gray-200
// //   rounded-2xl
// //   p-4 shadow-sm
// // `;
// // const TitleWrap = tw.div`
// //   flex flex-col md:text-right
// // `;

// // const Title = tw.h2`
// //   text-xl font-bold text-gray-900
// // `;

// // const Subtitle = tw.p`
// //   text-xs text-gray-500
// // `;
// // const OwnerCard = tw.div`
// //   flex items-center gap-3
// //   bg-white
// //   border border-gray-200
// //   rounded-full
// //   px-4 py-2
// //   shadow-sm
// //   text-center
// //   w-fit
// // `;

// // const UserImage = tw.img`
// //   w-9 h-9 rounded-full bg-primary-color
// // `;

























// import { useState, useRef, useEffect } from "react";
// import { Formik, Field, Form } from "formik";
// import * as Yup from "yup";
// import tw from "tailwind-styled-components";
// import { toast } from "react-toastify";
// import { MdClose, MdEdit } from "react-icons/md";
// import { FaPhone, FaWhatsapp } from "react-icons/fa";
// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";
// import { FormControl } from "@mui/material";
// import { Autocomplete } from "@react-google-maps/api";
// import { useMutation } from "react-query";
// import axios from "axios";
// import { useParams } from "react-router-dom";

// import Config, {
//   landlord_property_type,
//   listing_type,
//   bhk_options,
//   propertyFeatures,
// } from "../../Config";

// import Images from "../../Images";

// import {
//   CardWrapper,
//   CombineInputGroup,
//   FieldWrappers,
//   InputGroup,
//   SelectionCard,
// } from "../../Components/Styles/InputStyles";

// import { furnishedOptions, preferredTenantOptions } from "../../helpers";

// const InventoryForm = () => {
//   const { id: ownerId } = useParams();

//   const [apiData, setApiData] = useState(null);

//   const autocompleteRef = useRef(null);

//   const validationSchema = Yup.object({
//     inventoryName: Yup.string().required("Required"),
//     listingType: Yup.string().required("Required"),
//     inventoryType: Yup.string().required("Required"),
//     address: Yup.string().required("Required"),
//     rent: Yup.number().required("Required"),
//   });

//   const initialValues = {
//     inventoryName: "",
//     listingType: "",
//     inventoryType: "",
//     inventorySubType: "",
//     buildingName: "",
//     flatNo: "",
//     address: "",
//     carpetArea: "",
//     buildUpArea: "",
//     rent: "",
//     securityDeposit: "",
//     maintenanceCharges: "",
//     furnishedType: "",
//     preferredTenantType: "",
//     foodPreference: "",
//     features: [],
//   };

//   const fetchFunction = async () => {
//     const response = await axios.get(`${Config.apiUrl}/form/share/${ownerId}`);
//     return response.data;
//   };

//   const { mutate: getListMutate } = useMutation(fetchFunction, {
//     onSuccess: (res) => {
//       setApiData(res?.data);
//     },
//   });

//   useEffect(() => {
//     getListMutate();
//   }, []);

//   const createInventory = async (values) => {
//     return axios.post(`${Config.apiUrl}/form/create`, values);
//   };

//   const { mutate, isLoading: isCreating } = useMutation(createInventory, {
//     onSuccess: () => toast.success("Created Successfully"),
//     onError: () => toast.error("Error creating inventory"),
//   });

//   const handlePlaceSelect = (setFieldValue) => {
//     const place = autocompleteRef.current.getPlace();

//     if (place?.formatted_address) {
//       setFieldValue("address", place.formatted_address);
//     }
//   };

//   const foodPreferenceOptions = [
//     { value: 1, label: "Veg" },
//     { value: 2, label: "Non-Veg" },
//     { value: 3, label: "Whatever" },
//   ];

//   return (
//     <MainWrapper>
//       {/* HEADER */}
//       <Header>
//         <HeaderContainer>
//           <Logo src={Images.Logo} alt="Logo" />

//           <div className="text-sm font-medium text-gray-500">
//             Premium Property Listing
//           </div>
//         </HeaderContainer>
//       </Header>

//       <Container>
//         {/* HERO SECTION */}
//         <TopHero>
//           <div className="flex items-center gap-4">
//             <HeroAvatar src={Images.Avatar} />

//             <div>
//               <p className="text-xs uppercase tracking-wider text-gray-400 font-semibold">
//                 Property Owner
//               </p>

//               <h2 className="text-lg font-semibold text-gray-900">
//                 {apiData?.name || "Anurag Singh"}
//               </h2>

//               <div className="flex items-center gap-3 mt-1 flex-wrap">
//                 <span className="text-sm text-gray-500">
//                   {apiData?.mobile || "+91 9876543210"}
//                 </span>

//                 <div className="flex items-center gap-2">
//                   <IconButton
//                     onClick={() => {
//                       const phone = apiData?.mobile;

//                       if (!phone) return;

//                       window.open(`https://wa.me/${phone}`, "_blank");
//                     }}
//                   >
//                     <FaWhatsapp size={14} />
//                   </IconButton>

//                   <IconButton
//                     onClick={() => {
//                       const phone = apiData?.mobile;

//                       if (!phone) return;

//                       window.location.href = `tel:${phone}`;
//                     }}
//                   >
//                     <FaPhone size={13} />
//                   </IconButton>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="md:text-right">
//             <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
//               List Your Property
//             </h1>

//             <p className="text-sm text-gray-500 mt-1">
//               Create a premium inventory listing
//             </p>
//           </div>
//         </TopHero>

//         {/* FORM */}
//         <Formik
//           initialValues={initialValues}
//           validationSchema={validationSchema}
//           onSubmit={(values) => mutate(values)}
//         >
//           {({ values, setFieldValue, errors, touched, handleBlur }) => (
//             <Form className="space-y-6">
//               {/* PROPERTY DETAILS */}
//               <FormSection>
//                 <SectionTitle>Property Details</SectionTitle>

//                 <CombineInputGroup>
//                   <InputGroup>
//                     <Label>Listing Name *</Label>

//                     <StyledFieldWrapper>
//                       <Field
//                         name="inventoryName"
//                         placeholder="Enter listing name"
//                       />
//                     </StyledFieldWrapper>
//                   </InputGroup>

//                   <InputGroup>
//                     <Label>Listing Type *</Label>

//                     <FormControl fullWidth>
//                       <Select
//                         value={values.listingType}
//                         onChange={(e) =>
//                           setFieldValue("listingType", e.target.value)
//                         }
//                         displayEmpty
//                         style={{
//                           height: "50px",
//                           borderRadius: "16px",
//                           background: "#f9fafb",
//                         }}
//                       >
//                         <MenuItem value="" disabled>
//                           Select Listing Type
//                         </MenuItem>

//                         {listing_type.map((option) => (
//                           <MenuItem
//                             key={option.value}
//                             value={option.value}
//                           >
//                             {option.label}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </InputGroup>
//                 </CombineInputGroup>

//                 <CombineInputGroup>
//                   <InputGroup>
//                     <Label>Inventory Type *</Label>

//                     <FormControl fullWidth>
//                       <Select
//                         value={values.inventoryType}
//                         onChange={(e) =>
//                           setFieldValue("inventoryType", e.target.value)
//                         }
//                         displayEmpty
//                         style={{
//                           height: "50px",
//                           borderRadius: "16px",
//                           background: "#f9fafb",
//                         }}
//                       >
//                         <MenuItem value="" disabled>
//                           Select Inventory Type
//                         </MenuItem>

//                         {landlord_property_type.map((option) => (
//                           <MenuItem
//                             key={option.value}
//                             value={option.value}
//                           >
//                             {option.label}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </InputGroup>

//                   <InputGroup>
//                     <Label>BHK</Label>

//                     <StyledFieldWrapper>
//                       <Field
//                         readOnly
//                         value={
//                           bhk_options.find(
//                             (opt) =>
//                               opt.value === values.inventorySubType,
//                           )?.label || "Select BHK"
//                         }
//                       />

//                       <MdEdit className="text-gray-400 mr-2" />
//                     </StyledFieldWrapper>
//                   </InputGroup>
//                 </CombineInputGroup>

//                 <InputGroup>
//                   <Label>Address *</Label>

//                   <StyledFieldWrapper className="pl-0">
//                     <Autocomplete
//                       onLoad={(autocomplete) =>
//                         (autocompleteRef.current = autocomplete)
//                       }
//                       onPlaceChanged={() =>
//                         handlePlaceSelect(setFieldValue)
//                       }
//                     >
//                       <input
//                         type="text"
//                         value={values.address}
//                         onChange={(e) =>
//                           setFieldValue("address", e.target.value)
//                         }
//                         placeholder="Enter property address"
//                         className="w-full bg-transparent outline-none border-none pl-4"
//                       />
//                     </Autocomplete>

//                     {values.address && (
//                       <button
//                         type="button"
//                         onClick={() =>
//                           setFieldValue("address", "")
//                         }
//                         className="mr-3 text-gray-400"
//                       >
//                         <MdClose />
//                       </button>
//                     )}
//                   </StyledFieldWrapper>
//                 </InputGroup>

//                 <CombineInputGroup>
//                   <InputGroup>
//                     <Label>Building / Tower</Label>

//                     <StyledFieldWrapper>
//                       <Field
//                         name="buildingName"
//                         placeholder="Enter building name"
//                       />
//                     </StyledFieldWrapper>
//                   </InputGroup>

//                   <InputGroup>
//                     <Label>Flat / House No</Label>

//                     <StyledFieldWrapper>
//                       <Field
//                         name="flatNo"
//                         placeholder="Enter flat number"
//                       />
//                     </StyledFieldWrapper>
//                   </InputGroup>
//                 </CombineInputGroup>
//               </FormSection>

//               {/* AREA DETAILS */}
//               <FormSection>
//                 <SectionTitle>Area Details</SectionTitle>

//                 <CombineInputGroup>
//                   <InputGroup>
//                     <Label>Carpet Area (sqft)</Label>

//                     <StyledFieldWrapper>
//                       <Field
//                         name="carpetArea"
//                         placeholder="Enter carpet area"
//                       />
//                     </StyledFieldWrapper>
//                   </InputGroup>

//                   <InputGroup>
//                     <Label>Built-up Area (sqft)</Label>

//                     <StyledFieldWrapper>
//                       <Field
//                         name="buildUpArea"
//                         placeholder="Enter built-up area"
//                       />
//                     </StyledFieldWrapper>
//                   </InputGroup>
//                 </CombineInputGroup>
//               </FormSection>

//               {/* PRICING */}
//               <FormSection>
//                 <SectionTitle>Pricing Details</SectionTitle>

//                 <InputGroup>
//                   <Label>Monthly Rent (₹) *</Label>

//                   <StyledFieldWrapper>
//                     <Field
//                       name="rent"
//                       placeholder="Enter monthly rent"
//                     />
//                   </StyledFieldWrapper>
//                 </InputGroup>

//                 <CombineInputGroup>
//                   <InputGroup>
//                     <Label>Security Deposit (₹)</Label>

//                     <StyledFieldWrapper>
//                       <Field
//                         name="securityDeposit"
//                         placeholder="Enter deposit"
//                       />
//                     </StyledFieldWrapper>
//                   </InputGroup>

//                   <InputGroup>
//                     <Label>Maintenance Charges (₹)</Label>

//                     <StyledFieldWrapper>
//                       <Field
//                         name="maintenanceCharges"
//                         placeholder="Enter maintenance"
//                       />
//                     </StyledFieldWrapper>
//                   </InputGroup>
//                 </CombineInputGroup>
//               </FormSection>

//               {/* PREFERENCES */}
//               <FormSection>
//                 <SectionTitle>Preferences</SectionTitle>

//                 <InputGroup>
//                   <Label>Furnished Type</Label>

//                   <CardWrapper>
//                     {furnishedOptions.map((option) => (
//                       <PremiumCard
//                         key={option.value}
//                         type="button"
//                         onClick={(e) => {
//                           e.preventDefault();

//                           setFieldValue(
//                             "furnishedType",
//                             option.value,
//                           );
//                         }}
//                         className={
//                           values.furnishedType === option.value
//                             ? "active"
//                             : ""
//                         }
//                       >
//                         {option.label}
//                       </PremiumCard>
//                     ))}
//                   </CardWrapper>
//                 </InputGroup>

//                 <InputGroup>
//                   <Label>Preferred Tenant</Label>

//                   <CardWrapper>
//                     {preferredTenantOptions.map((option) => (
//                       <PremiumCard
//                         key={option.value}
//                         type="button"
//                         onClick={(e) => {
//                           e.preventDefault();

//                           setFieldValue(
//                             "preferredTenantType",
//                             option.value,
//                           );
//                         }}
//                         className={
//                           values.preferredTenantType === option.value
//                             ? "active"
//                             : ""
//                         }
//                       >
//                         {option.label}
//                       </PremiumCard>
//                     ))}
//                   </CardWrapper>
//                 </InputGroup>

//                 <InputGroup>
//                   <Label>Food Preference</Label>

//                   <CardWrapper>
//                     {foodPreferenceOptions.map((option) => (
//                       <PremiumCard
//                         key={option.value}
//                         type="button"
//                         onClick={(e) => {
//                           e.preventDefault();

//                           setFieldValue(
//                             "foodPreference",
//                             option.value,
//                           );
//                         }}
//                         className={
//                           values.foodPreference === option.value
//                             ? "active"
//                             : ""
//                         }
//                       >
//                         {option.label}
//                       </PremiumCard>
//                     ))}
//                   </CardWrapper>
//                 </InputGroup>
//               </FormSection>

//               {/* FEATURES */}
//               <FormSection>
//                 <SectionTitle>Features</SectionTitle>

//                 <StyledFieldWrapper>
//                   <Field
//                     readOnly
//                     value={
//                       values.features?.length
//                         ? values.features.join(", ")
//                         : "Select Features"
//                     }
//                   />

//                   <MdEdit className="text-gray-400 mr-2" />
//                 </StyledFieldWrapper>
//               </FormSection>

//               {/* SUBMIT */}
//               <SubmitWrapper>
//                 <SubmitBtn
//                   type="submit"
//                   disabled={isCreating}
//                 >
//                   {isCreating
//                     ? "Saving..."
//                     : "Create Inventory"}
//                 </SubmitBtn>
//               </SubmitWrapper>
//             </Form>
//           )}
//         </Formik>

//         <Footer>
//           © {new Date().getFullYear()} Kipinn. All rights reserved.
//         </Footer>
//       </Container>
//     </MainWrapper>
//   );
// };

// export default InventoryForm;

// /* STYLES */

// const MainWrapper = tw.div`
//   min-h-screen
//   bg-gradient-to-br from-gray-50 via-white to-teal-50
// `;

// const Header = tw.div`
//   sticky top-0 z-50
//   bg-white/80 backdrop-blur-lg
//   border-b border-gray-100
// `;

// const HeaderContainer = tw.div`
//   max-w-6xl
//   mx-auto
//   px-5 py-4

//   flex items-center justify-between
// `;

// const Logo = tw.img`
//   w-20
// `;

// const Container = tw.div`
//   max-w-6xl
//   mx-auto
//   px-4 py-6
// `;

// const TopHero = tw.div`
//   bg-white
//   border border-gray-200

//   rounded-[28px]

//   p-5 md:p-7

//   shadow-sm

//   flex flex-col md:flex-row
//   items-start md:items-center
//   justify-between

//   gap-6

//   mb-6
// `;

// const HeroAvatar = tw.img`
//   w-14 h-14
//   rounded-2xl
//   border border-gray-200
// `;

// const IconButton = tw.button`
//   w-8 h-8
//   rounded-xl

//   flex items-center justify-center

//   bg-gray-100
//   hover:bg-primary-color
//   hover:text-white

//   transition-all duration-200
// `;

// const FormSection = tw.div`
//   bg-white

//   border border-gray-200

//   rounded-[28px]

//   p-5 md:p-6

//   shadow-sm

//   space-y-5
// `;

// const SectionTitle = tw.h3`
//   text-lg
//   font-semibold
//   text-gray-900
// `;

// const Label = tw.label`
//   text-sm
//   font-medium
//   text-gray-600
// `;

// const StyledFieldWrapper = tw(FieldWrappers)`
//   border border-gray-100
//   bg-gray-50

//   rounded-2xl

//   h-12

//   transition-all duration-200

//   focus-within:border-primary-color
//   focus-within:bg-white
// `;

// const PremiumCard = tw.button`
//   px-4 py-3

//   rounded-2xl

//   border border-gray-100

//   bg-gray-50

//   text-sm font-medium text-gray-700

//   transition-all duration-200

//   hover:border-primary-color
//   hover:bg-teal-50

//   &.active {
//     background: linear-gradient(to right, #14b8a6, #2dd4bf);
//     color: white;
//     border-color: transparent;
//     box-shadow: 0 10px 25px rgba(45, 212, 191, 0.2);
//   }
// `;

// const SubmitWrapper = tw.div`
//   flex justify-end
// `;

// const SubmitBtn = tw.button`
//   h-12
//   px-8

//   rounded-2xl

//   bg-gradient-to-r from-primary-color to-teal-400

//   text-white
//   font-semibold

//   shadow-lg shadow-teal-100

//   hover:scale-[1.01]
//   active:scale-[0.99]

//   transition-all duration-200

//   disabled:opacity-50
// `;

// const Footer = tw.div`
//   text-center
//   text-sm
//   text-gray-400

//   mt-8
//   mb-4
// `;
